mutation SendEventReminder($eventId: ID!, $kind: EventReminderKindEnum!) {
  sendEventReminder(input: { eventId: $eventId, kind: $kind }) {
    queuedCount
  }
}
